import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const SubscribeFourColumns = () => import(/* webpackChunkName: "snippet-items-subscribe-four-columns" */ 'components/SnippetTemplate/Items/FourColumns')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(SubscribeFourColumns, {props: eval(this.elemId)})
        })
    }
}
